import ArticleCard from "./articleCard";

const Articles = ({ articles }) => {
  return (
    <div className="flex flex-col gap-16">
      {articles.map((i, n) => (
        <ArticleCard article={i} key={i.attributes.slug} />
      ))}
    </div>
  );
};

export default Articles;
